export class CommonConstant {
  // Paging
  public static readonly PAGING_PAGE_SIZE = 20;
  public static readonly REWORK_PAGING_PAGE_SIZE = 50;
  public static readonly PAGING_PAGE_INDEX = 1;
  public static readonly PAGING_OPTIONS = [20, 50, 100];
  public static readonly REWORK_PAGING_OPTIONS = [50, 200, 1000];
  //
  public static readonly USER_TOKEN = 'USER_TOKEN';
  public static readonly SUPER_ADMIN_ROLE = 'SUPER_ADMIN';
  public static readonly FIREBASE_USER_CREDENTIAL = 'FIREBASE_USER_CREDENTIAL';
  public static readonly DEFAULT_LANGUAGE = 'fr';
  public static readonly REGEX_STRONG_PASSWORD = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,128}$'
  );
  public static readonly PHONE_NUMBER_REGEX =
    /(\+*\d{1,})*([ |\(])*(\d{3})[^\d]*(\d{3})[^\d]*(\d{4})/;
  public static readonly REGEX_PLAIN_NUMBER = /^\d+$/;
  public static readonly DATE_FORMAT_DISPLAY = 'dd/MM/yyyy';
  public static readonly DATE_FORMAT_DISPLAY_2 = 'dd/MM/yy h:mm';
  public static readonly DATE_FORMAT_DISPLAY_3 = 'DD/MM/yyyy';
  public static readonly DATE_FORMAT_FOR_CONVERT = 'yyyy-MM-DD';
  public static readonly DATE_FORMAT_FOR_EXPORT_CSV = 'yyyy-mm-dd-hh-mm-ss';
  public static readonly TIME_FORMAT_DISPLAY = 'HH:mm';
  public static readonly DATE_PICKER_FORMATS = {
    parse: {
      dateInput: 'DD/MM/yyyy',
    },
    display: {
      dateInput: 'DD/MM/yyyy',
      monthYearLabel: 'MMM yyyy',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM yyyy',
    }
  }
  // Input
  public static readonly INPUT_DEBOUNCE_INTERVAL = 500;
  public static readonly INPUT_DEBOUNCE_THRESH_HOLD = 4;

  // tslint:disable:max-line-length
  public static readonly APP_LOGO =
    'https://storage.googleapis.com/sainte-maxime-722df.appspot.com/public-resources/logo.png';
  public static readonly APP_LOGO_MEDIUM =
    'https://storage.googleapis.com/sainte-maxime-722df.appspot.com/public-resources/logo-medium.png';
  public static readonly APP_LOGO_SMALL =
    'https://storage.googleapis.com/sainte-maxime-722df.appspot.com/public-resources/logo-small.png';
  public static readonly AUTH_BACKGROUND =
    'https://storage.googleapis.com/sainte-maxime-722df.appspot.com/public-resources/auth-background.png';

  // SnackBar Config
  public static readonly DEFAULT_SNACKBAR_CONFIG_DURATION = 2500;
  public static readonly DEFAULT_SNACKBAR_CONFIG = {
    duration: CommonConstant.DEFAULT_SNACKBAR_CONFIG_DURATION,
    panelClass: ['default__snack-bar'],
  };
  public static readonly SUCCESS_SNACKBAR_CONFIG = {
    duration: CommonConstant.DEFAULT_SNACKBAR_CONFIG_DURATION,
    panelClass: ['success__snack-bar'],
  };
  public static readonly FAILURE_SNACKBAR_CONFIG = {
    duration: CommonConstant.DEFAULT_SNACKBAR_CONFIG_DURATION,
    panelClass: ['failure__snack-bar'],
  };

  // Field Config
  public static readonly FIELD_CONTROL_MAX_LENGTH = {
    email: 320,
    password: 128,
    city: 100,
    street: 100,
    streetNumber: 20,
    name: 100,
    phone: 10,
  }
  public static readonly FIELD_CONTROL_MIN_LENGTH = {
    email: 3,
    password: 6,
  }
  public static readonly FIELD_CONTROL_MAX_NUMBER = {
    annualPrice: 1000,
    maximumPerUser: 1000,
    quotas: 1000,
    readingTime: 60,
  }
  public static readonly FIELD_CONTROL_MIN_NUMBER = {
    annualPrice: 0,
    maximumPerUser: 1,
    quotas: 0,
    readingTime: 1,
  }

  // Default value
  public static readonly DEFAULT_COUNTRY_CODE = 'FR'; // Country name: FRANCE
  public static readonly DEFAULT_CITY_CODE = '83115'; // City name: Sainte-Maxime
  public static readonly DEFAULT_EXPORT_FILE_PAGINATION_CONFIG = {
    currentPage: 1,
    perPage: 5000,
    maxPage: 1,
  };
}
